import {
  Box,
  Button,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import Image from "next/image";
import { FormatedTime } from "../genericComponents/formated-time/FormatedTime";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
import { AddToCartService } from "@/app/services/cart";

interface SearchServiceMobileCardProps {
  item: any;
  setReloadViewDetailsItem: any;
  updateCard: any;
  setUpdateCard: any;
  setOpenMaxService: any;
  handleOpenViewDetailsRsOne: any;
}

export const SearchServiceMobileCard: React.FC<
  SearchServiceMobileCardProps
> = ({
  item,
  setReloadViewDetailsItem,
  updateCard,
  setUpdateCard,
  setOpenMaxService,
  handleOpenViewDetailsRsOne,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isClicked, setIsClicked] = React.useState(false);
  const [value, setVaue] = React.useState(1);
  const currencyCode = useCurrencyCode();
  const addToCartService = React.useMemo(() => new AddToCartService(), []);

  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(item?.id, item?.cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, item?.id, item?.cid, setUpdateCard]);

  const handleClickButton = async (item: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    if (item?.addOn == true) {
      handleOpenViewDetailsRsOne(item);
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        item?.id,
        true,
        item?.cid,
        item?.coverImage?.secureHttpPath,
        item?.aboutList,
        item?.subHeading,
        item?.serviceCharge,
        item?.productCost,
        item?.min,
        item?.specialPrice,
        item?.specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson.count);
        setIsClicked(true);
        setReloadViewDetailsItem(true);
        setIsLoading(false);
      } else {
        setIsClicked(false);
        setReloadViewDetailsItem(true);
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async (item: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      item?.id,
      false,
      item?.cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      setReloadViewDetailsItem(true);
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setReloadViewDetailsItem(true);
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async (item: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      item?.id,
      true,
      item?.cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      setReloadViewDetailsItem(true);
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setReloadViewDetailsItem(true);
      setIsLoading(false);
    }
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title" sx={{ padding: "1rem 1rem 0.5rem" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          <Box sx={{ position: "relative" }}>
            {item?.serviceTag && (
              <Typography
                variant="body2"
                sx={{
                  position: "absolute",
                  top: "-10px",
                  left: "-10px",
                  padding: "2px 4px",
                  borderRadius: "4px",
                  background: "#ffbf00",
                  textTransform: "capitalize",
                  textWrap: "nowrap",
                  fontSize: "12px",
                }}
              >
                {item?.serviceTag}
              </Typography>
            )}
            <Image
              src={item?.coverImage?.secureHttpPath}
              width={500}
              height={500}
              style={{
                objectFit: "cover",
                minWidth: "4.5rem",
                width: "4.5rem",
                minHeight: "4.5rem",
                height: "4.5rem",
                borderRadius: "0.5rem",
              }}
              alt="category"
            />
          </Box>
          <Box
            sx={{
              marginLeft: "0.5rem",
              width: "-webkit-fill-available",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ lineHeight: "1rem" }}>
                <Typography
                  variant="body2"
                  sx={{ color: "black", fontWeight: "bold" }}
                >
                  {item?.name}
                </Typography>
                <Typography variant="caption" sx={{ color: "black" }}>
                  {item?.subHeading}
                </Typography>
              </Box>
              <Box sx={{ paddingLeft: "4px" }}>
                {isLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "115px",
                      background: "none",
                      borderRadius: "10rem",
                      border: "1px solid #15741a",
                      height: "32px",
                    }}
                  >
                    <CircularProgress size="25px" color="success" />
                  </Box>
                ) : isClicked ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      width: "115px",
                      height: "32px",
                      background: "#15741a",
                      borderRadius: "10rem",
                      color: "white",
                    }}
                  >
                    <RemoveIcon
                      onClick={(e) => handleValueDecrease(item, e)}
                      sx={{ cursor: "pointer" }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {value}
                    </Typography>
                    <AddIcon
                      onClick={(e) => handleValueIncrease(item, e)}
                      sx={{ cursor: "pointer" }}
                    />
                  </Box>
                ) : (
                  <Button
                    variant="contained"
                    sx={{
                      fontSize: "11px",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      padding: "6px 20px",
                      borderRadius: "10rem",
                      width: "115px",
                      height: "32px",
                      boxShadow: "none",
                      background: "#15741a",
                    }}
                    color="success"
                    onClick={(e) => handleClickButton(item, e)}
                  >
                    Add to Cart
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: "#15741a", fontWeight: "bold" }}
              >
                {currencyCode}
                {item?.amount}
              </Typography>
              &nbsp; &nbsp;
              <Typography
                variant="body1"
                sx={{
                  color: "#b9b4b4",
                  textDecoration: "line-through",
                }}
              >
                {currencyCode}
                {item?.mrp}
              </Typography>
              &nbsp; &nbsp;
              <Typography
                variant="body1"
                sx={{ color: "#15741a", fontWeight: "bold" }}
              >
                Save {currencyCode}
                {item?.discount}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ padding: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            color: "black",
            padding: "8px 0px",
          }}
        >
          <WatchLaterIcon sx={{ fontSize: "16px" }} />
          <Typography
            variant="body2"
            sx={{ paddingLeft: "8px", fontWeight: "bold" }}
          >
            <FormatedTime min={item?.min} />
          </Typography>
        </Box>
        {item?.aboutList?.map((nestedItem: any, index: any) => {
          const parts = nestedItem.split("-");
          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <CheckIcon
                sx={{ color: "#15741a", fontSize: "12px" }}
                fontSize="small"
              />
              &nbsp;
              <Typography variant="body2" sx={{ color: "black" }}>
                {parts.length > 1 ? (
                  <>
                    <strong>{parts[0].trim()} -</strong>{" "}
                    {parts.slice(1).join("-").trim()}
                  </>
                ) : (
                  nestedItem
                )}
              </Typography>
            </Box>
          );
        })}
      </DialogContent>
    </>
  );
};
